import React from "react";
import { Link } from "react-router-dom";
import Wordmark from "./Wordmark";
import { useRegion } from "@/contexts/RegionContext";
import { NEUTRAL_FOOTER } from "@/pages/Landing";

const FOOTER_COLS = [
    {
        title: "Platform",
        links: [
            { label: "Geometry", href: "/#platform" },
            { label: "Materials", href: "/#platform" },
            { label: "Solvers", href: "/#platform" },
        ],
    },
    {
        title: "Workflows",
        links: [
            { label: "Plan", href: "/#workflows" },
            { label: "Monitor", href: "/#workflows" },
            { label: "Learn", href: "/#workflows" },
        ],
    },
    {
        title: "Pricing",
        links: [
            { label: "Plans", href: "/pricing" },
            { label: "Enterprise", href: "/demo" },
        ],
    },
    {
        title: "Documentation",
        links: [
            { label: "Methodology", href: "/#documentation" },
            { label: "Codes & standards", href: "/#documentation" },
            { label: "Changelog", href: "/#documentation" },
        ],
    },
    {
        title: "Contact",
        links: [
            { label: "Request demo", href: "/demo" },
            { label: "Email us", href: "/demo" },
        ],
    },
];

export const Footer = () => {
    const { regionData, detectionSource } = useRegion();
    const footerStandardsLine =
        detectionSource === "fallback"
            ? NEUTRAL_FOOTER
            : (regionData?.footer_line || NEUTRAL_FOOTER);

    return (
        <footer
            data-testid="site-footer"
            className="mt-24 border-t border-[#d8dcdd] bg-[#f6f7f6]"
        >
            <div className="mx-auto max-w-[1280px] px-6 lg:px-10 pt-16 pb-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    {/* Wordmark column */}
                    <div className="md:col-span-4 flex flex-col gap-4">
                        <Wordmark variant="light" size="text-[18px]" />
                        <p className="text-[13.5px] text-[#5a6669] max-w-[28ch] leading-[1.55]">
                            Concrete pour intelligence for mass concrete thermal
                            control and early-age cracking risk assessment.
                        </p>
                    </div>

                    {/* Link columns */}
                    <div className="md:col-span-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8">
                        {FOOTER_COLS.map((col) => (
                            <div
                                key={col.title}
                                className="flex flex-col gap-3"
                            >
                                <div className="tc-eyebrow text-[#0e1416]">
                                    {col.title}
                                </div>
                                <ul className="flex flex-col gap-2">
                                    {col.links.map((link) => (
                                        <li key={link.label}>
                                            <Link
                                                to={link.href}
                                                data-testid={`footer-link-${col.title.toLowerCase()}-${link.label
                                                    .toLowerCase()
                                                    .replace(/\s+/g, "-")}`}
                                                className="text-[13px] text-[#5a6669] hover:text-[#01696f] transition-colors"
                                            >
                                                {link.label}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Bottom row */}
            <div className="border-t border-[#d8dcdd]">
                <div className="mx-auto max-w-[1280px] px-6 lg:px-10 py-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <p
                        data-testid="footer-attribution"
                        className="tc-mono text-[11px] text-[#5a6669]"
                    >
                        © 2026 Concrete Control LLC ·{" "}
                        <a
                            href="https://www.concrete-control.com"
                            className="hover:text-[#01696f] transition-colors"
                        >
                            www.concrete-control.com
                        </a>
                    </p>
                    <p className="tc-mono text-[11px] text-[#8a9498]">
                        v0.1 · build.phase1
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
